<template>
  <div>
    <app-collapse
        accordion
        :type="'margin'"
    >

      <app-collapse-item
          v-for="(question, index) in lessonsRender"
          :key="question.id"
          :title="`${question.name} ${question.blocked ? 'Следующий урок' : ''}`"
      >
        <div class="answer">
          <template v-if="!question.blocked">
            <h5>{{ 'Классная работа' }}</h5>
            <a
                v-for="classWorkFile in question.classwork_files"
                :key="classWorkFile.id"
                :download="classWorkFile.file_name"
                :href="classWorkFile.file"

            >
              {{ classWorkFile.file_name }}
              <br>
            </a>
            <div class="tests mt-3">
              <template v-for="ques in question.questions">
                <h6 class="d-block mb-1" :key="ques.id">
                  {{ ques.title }}
                </h6>
                <label class="d-block" v-for="answer in ques.answers" :key="answer.id">
                  <input type="radio" :name="ques.title" :value="answer.id">
                  <span> {{ answer.title }} </span>
                </label>
              </template>
            </div>
            <br>

            <h5>{{ 'Домашняя работа' }}</h5>
            <a
                v-for="homeWorkFile in question.homework_files"
                :key="'homeworkFile' + homeWorkFile.id"
                :href="homeWorkFile.file"
                :download="homeWorkFile.file_name"
            >
              {{ homeWorkFile.file_name }}
              <br>
            </a>
            <br>
            <div class="uploaded-homeworks">
              <div
                  v-for="(homeWork) in question.homeworks"
                  :key="'homework' + homeWork.id"
                  class="d-flex mb-1 align-items-center justify-content-between">
                <a
                    :href="homeWork.file"
                    :download="homeWork.file_name"
                >
                  {{ homeWork.file_name }}
                  <br>
                </a>
                <template v-if="homeWork.status === 0">
                  <b-button variant="primary" class="btn-default btn cursor-pointer" @click="removeHomeWorkFile(homeWork.id)"> Удалить
                    домашнее задание
                  </b-button>
                </template>
                <template v-else>
                  <b-button variant="primary" @click="showEvaluation(homeWork.id, question.id)" class="btn-default btn cursor-pointer">
                    Посмотреть оценку
                  </b-button>
                </template>
              </div>
            </div>
            <label>
              <span>
                {{ 'Загрузить свою домашнюю работу' }}
              </span>
              <br>
              <input @input="uploadHomeWorkFile($event, question.id)" type="file">
            </label>
          </template>
          <template v-else>
            {{ 'Вам нужно пройти предыдущий урок, чтобы получить доступ к этому' }}
          </template>
        </div>
      </app-collapse-item>
    </app-collapse>
    <b-modal
        ref="gradeModal"
        id="modal-1"
        :title="`Ваша оценка - ${activeGrade}`"
        ok-only
        ok-title="Понятно"
    >
      <b-card-text>
        {{activeDescription}}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {  BFormRadioGroup, BFormRadio, BFormGroup} from 'bootstrap-vue'
import { createNamespacedHelpers } from 'vuex';

const {
  mapActions,
  mapState,
  mapGetters,
} = createNamespacedHelpers('courses');

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BButton,
    BModal
  },
  name: "Subject inner",
  methods: {
    ...mapActions(['getLessons', 'uploadHomework', 'removeHomeWork']),
    showEvaluation(id, lessonId) {
      const activeLesson = this.lessons.find((lesson) => lesson.id === lessonId);
      const activeHomeWork = activeLesson.homeworks.find((homework) => homework.id === id);
      this.activeGrade = activeHomeWork.grade;
      this.activeDescription = activeHomeWork.description;

      this.$refs.gradeModal.show();
    },
    calculateActiveAccordionHeight() {
      const activeAccordionAnswer = this.activeAccordion.querySelector('.answer');
      activeAccordionAnswer.style.maxHeight = `${activeAccordionAnswer.scrollHeight + 60}px`;
    },
    uploadHomeWorkFile($event, lessonId) {
      const options = new FormData();
      options.append('lesson_id', lessonId);
      options.append('file', $event.target.files[0]);
      options.append('program_id', this.$route.params.courseName);
      this.uploadHomework(options, this.$route.params.courseName)
          .then(() => {
            this.$bvToast.toast('Ваше домашнее задание успешно загружено', {
              variant: 'success',
              message: 'Домашнее задание загружено!',
              solid: true,
            })
          })
          .catch(() => {
            this.$bvToast.toast('Please try again later', {
              title: `Oops! Something went wrong...`,
              variant: 'danger',
              solid: true,
            })
          });
    },
    removeHomeWorkFile(id) {
      this.$bvModal
          .msgBoxConfirm('Please confirm that you want to delete everything.', {
            title: 'Please Confirm',
            size: 'sm',
            okVariant: 'primary',
            okTitle: 'Yes',
            cancelTitle: 'No',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            const options = {
              id,
              program_id: this.$route.params.courseName,
            };
            this.removeHomeWork(options)
                .then(() => {
                  this.$bvToast.toast('Ваше домашнее задание успешно удалено', {
                    variant: 'success',
                    message: 'Домашнее задание удалено!',
                    solid: true,
                  })
                })
                .catch(() => {
                  this.$bvToast.toast('Не удалось удалить ваше домашнее задание', {
                    variant: 'danger',
                    message: 'Скорее всего оно проверяется учителем!',
                    solid: true,
                  })
                })
          })

    },

  },
  computed: {
    ...mapState({
      lessons: (state) => state.lessons,
    }),
    ...mapGetters(['doneLessonsIds']),
    lessonsRender() {
      return this.lessons.map((lesson) => (this.doneLessonsIds.indexOf(lesson.id) === -1 ? {
        ...lesson,
        blocked: true,
      } : {
        ...lesson,
        blocked: false,
      }));
    },
  },
  data() {
    return {
      activeAccordion: '',
      activeGrade: '',
      activeDescription: '',
    };
  },
  created() {
    this.getLessons(this.$route.params.id);
  },
}


</script>

<style scoped>

</style>
